import watches from "../Image/categories/Watch.webp";
import jackets from "../Image/categories/Fashion.webp";
import tshirts from "../Image/categories/Tshirt.webp";
import shirts from "../Image/categories/Toys.webp";
import sportswear from "../Image/categories/Sports.webp";
import jeans from "../Image/categories/jeans.webp";
import footwear from "../Image/categories/sneakers.webp";
import earbuds from "../Image/categories/headphone.webp";
import smartwatch from "../Image/categories/smartwatch.webp";
import powerbank from "../Image/categories/Fashion.webp";
import camera from "../Image/categories/Fashion.webp";
import accessories from "../Image/categories/Electronic.webp";
import cricket from "../Image/categories/Sports.webp";

const categories = [
  { name: "Watches", image: watches },
  { name: "Jackets", image: jackets },
  { name: "T-Shirts", image: tshirts },
  { name: "Shirts", image: shirts },
  { name: "Sports Wear", image: sportswear },
  { name: "Jeans", image: jeans },
  { name: "Footwear", image: footwear },
  { name: "Headphones / Earbuds", image: earbuds },
  { name: "Smart Watches", image: smartwatch },
  { name: "Power Banks", image: powerbank },
  { name: "Cameras", image: camera },
  { name: "Accessories (chargers, cables)", image: accessories },
  { name: "Cricket / Football Gear", image: cricket },
];

export default categories;
